import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import {
  convertData,
  cutName,
  dateFormat,
  splitMissionName,
} from "../../../services/Utils/functionService";
import Camembert from "../../../components/Cac/Partner/Utils/MonitoringElements/Camembert";
import Return from "../../../assets/icons/return.svg";
import ModalDocRequestDetails from "../../../components/Cac/Partner/Request/ModalDocRequestDetails";
import StatusRequest from "../../../components/Cac/Customer/Request/StatusRequest";
import { useCustomerRequestsStore } from "../../../stores/Cac/Customer/customerRequests";
import { useRecoveryFileStore } from "../../../stores/Utils/recoveryFIle";
import RequestDocuments from "../../../components/Cac/Customer/Request/RequestDocuments";
import { usePartnerRequestsStore2 } from "../../../stores/Cac/Partner/partnerRequests";
import eye from "../../../assets/icons/eye.svg";
import useModal from "../../../hooks/useModal";
import RelaunchPopup from "../../../components/Cac/Partner/Utils/RelaunchPopup";
import useTooltip from "../../../hooks/useTooltip";
import {
  getMissionDataByCustomer,
  getPercentageMission,
  relaunchData,
} from "../../../services/Api/customerService";
import { useTokenContext } from "../../../context/tokenContext";
import { ToastContainer } from "react-toastify";
import SideBar from "../../../components/Layout/SideBar";
import Header from "../../../components/Layout/Header";
import Footer from "../../../components/Layout/Footer";
import ProgressBar from "../../../components/Cac/Partner/Utils/MonitoringElements/ProgressBar";
import { showToastError } from "../../../services/Toasts/toasts";

const RecoveryFile = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { idMission, idCustomer } = useParams();
  const { modalContent, isModalOpen, openModal, closeModal } = useModal();
  const { utp, utc } = useTokenContext();
  const { openDetailsCustomer, setOpenDetailsCustomer } =
    useCustomerRequestsStore();
  const [updateDetails, setUpdateDetails] = useState<boolean>(false);
  const [tooltipState, handleMouseEnter, handleMouseLeave] = useTooltip();
  const {
    percent,
    setPercent,
    customerName,
    setCustomerName,
    missionName,
    setMissionName,
    missionInProgress,
    setMissionInProgress,
    missionDeadLine,
    setMissionDeadLine,
    selectedIdsRequestDeadLine,
    setSelectedIdsRequestDeadLine,
    selectedIdsRequestInProgress,
    setSelectedIdsRequestInProgress,
    selectedAllDeadLine,
    setSelectedAllDeadLine,
    selectedAllInProgress,
    setSelectedAllInProgress,
  } = useRecoveryFileStore();
  const { requestId, setRequestId, openDetails, setOpenDetails } =
    usePartnerRequestsStore2();
  const { requestIdCustomer, setRequestIdCustomer } =
    useCustomerRequestsStore();
  const [activeTab, setActiveTab] = useState('deadline');

  useEffect(() => {
        getMissionDataByCustomer(Number(idCustomer), Number(idMission))
          .then((data) => {
            setMissionName(data.name);
            const customerNameCut = cutName(data.name);
            setCustomerName(customerNameCut);
            if (idCustomer && idMission)
              relaunchData(parseInt(idCustomer), parseInt(idMission))
                .then((res) => {
                  const filteredDataDeadline = res.data.filter(
                    (item: any) => item.State.id === 4
                  );
                  setMissionDeadLine(filteredDataDeadline);
                  const filteredDataInProgress = res.data.filter(
                    (item: any) => item.State.id === 1
                  );
                  setMissionInProgress(filteredDataInProgress);
                })
                .catch(() => showToastError(t("common.error")));
              })
              .catch(() => showToastError(t("common.error")));
            }, [
    updateDetails,
    openDetails,
    openDetailsCustomer,
    requestId,
    requestIdCustomer,
  ]);

  const handlSelectedAllDeadLine = () => {
    setSelectedAllDeadLine((prev) => !prev);

    if (!selectedAllDeadLine) {
      setSelectedIdsRequestDeadLine(
        missionDeadLine
          .map((item) => item.id)
          .filter((item): item is number => typeof item === "number")
      );
    } else {
      setSelectedIdsRequestDeadLine([]);
    }
  };

  const handlSelectedAllInProgress = () => {
    setSelectedAllInProgress((prev) => !prev);

    if (!selectedAllInProgress) {
      setSelectedIdsRequestInProgress(
        missionInProgress
          .map((item) => item.id)
          .filter((item): item is number => typeof item === "number")
      );
    } else {
      setSelectedIdsRequestInProgress([]);
    }
  };

  const handleCheckboxChangeDeadLine = (
    e: React.ChangeEvent<HTMLInputElement>,
    idRequest: number
  ) => {
    if (e.target.checked) {
      setSelectedIdsRequestDeadLine((prev) => [...prev, idRequest]);
    } else {
      setSelectedIdsRequestDeadLine((prev) =>
        prev.filter((id) => id !== idRequest)
      );
    }
  };

  const handleCheckboxChangeInProgress = (
    e: React.ChangeEvent<HTMLInputElement>,
    idRequest: number
  ) => {
    if (e.target.checked) {
      setSelectedIdsRequestInProgress((prev) => [...prev, idRequest]);
    } else {
      setSelectedIdsRequestInProgress((prev) =>
        prev.filter((id) => id !== idRequest)
      );
    }
  };

  return (
    <div className="w-screen h-screen bg-gradient-to-br from-slate-50 to-blue-50 flex flex-col justify-start items-start overflow-hidden">
      <Header />
      <div className="w-full flex justify-start items-start">
        {isModalOpen ? modalContent : null}
        <ModalDocRequestDetails setUpdateDetails={setUpdateDetails} />
        <RequestDocuments />
        <ToastContainer position="top-center" />
        <SideBar />
        
        <div className="flex flex-col justify-start items-center w-11/12 h-screen m-auto">
          {/* Header Section avec design moderne */}
          <div className="w-full bg-white rounded-2xl shadow-lg p-6 my-3 border border-gray-100">
            <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center gap-4">
              <div className="flex items-center gap-4">
                <div className="p-3 bg-yellow-trio  rounded-xl">
                  <svg className="w-6 h-6 text-gray-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                  </svg>
                </div>
                <div>
                  <h1 className="text-2xl font-bold text-gray-700 font-K2D">
                    {t("partner.recoveryTitle")}
                  </h1>
                  <div className="flex items-center gap-4 mt-1">
                    <p className="text-gray-600">
                      {t("dashboard.client")} : <span className="font-semibold text-blue-600">{customerName}</span>
                    </p>
                    <span className="text-gray-400">•</span>
                    <p className="text-gray-600">
                      {t("dashboard.mission")} : <span className="font-semibold text-blue-600">{splitMissionName(missionName)}</span>
                    </p>
                  </div>
                </div>
              </div>
              <div className="w-auto">
                <ProgressBar />
              </div>

            </div>
          </div>

          <div className="w-full bg-white rounded-2xl shadow-lg mb-3 border border-gray-100">
            <div className="flex justify-start items-center bg-white rounded-xl p-2 my-3">
              <button
                  type="button"
                  className="p-3 bg-gray-100 rounded-xl hover:bg-gray-200 transition-colors duration-200 cursor-pointer"
                  onClick={() => navigate(-1)}
                >
                  <img src={Return} alt="return" className="w-5 h-5" />
                </button>
              <div className="bg-blue-50 rounded-xl border border-blue-200 p-3 ml-4">
                <p className="text-gray-700 text-sm leading-relaxed">
                  {t("partner.recoveryHint")}
                </p>
              </div>
            </div>
          </div>

          {/* Tableau unique avec onglets */}
          <div className="w-full bg-white rounded-2xl shadow-lg border border-gray-100 overflow-hidden">
            {/* Onglets */}
            <div className="flex border-b border-gray-200">
              <button
                className={`px-6 py-4 text-sm font-medium transition-colors cursor-pointer duration-200 ${
                  activeTab === 'deadline' 
                    ? 'text-red-600 border-b-2 border-red-600 bg-red-50' 
                    : 'text-gray-500 hover:text-gray-700 hover:bg-gray-50'
                }`}
                onClick={() => setActiveTab('deadline')}
              >
                <div className="flex items-center gap-2">
                  <div className="p-1.5 bg-red-100 rounded-lg">
                    <svg className="w-4 h-4 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                  </div>
                  {t("partner.overdueRequests")} ({missionDeadLine.length})
                </div>
              </button>
              <button
                className={`px-6 py-4 text-sm font-medium transition-colors duration-200 ${
                  activeTab === 'inProgress' 
                    ? 'text-orange-600 border-b-2 border-orange-600 cursor-pointer bg-orange-50' 
                    : 'text-gray-500 hover:text-gray-700 hover:bg-gray-50'
                }`}
                onClick={() => setActiveTab('inProgress')}
              >
                <div className="flex items-center gap-2">
                  <div className="p-1.5 bg-orange-100 rounded-lg">
                    <svg className="w-4 h-4 text-orange-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                  </div>
                  {t("partner.pendingRequests")} ({missionInProgress.length})
                </div>
              </button>
            </div>

            {/* Header du tableau avec bouton d'action */}
            <div className="p-6 border-b border-gray-100">
              <div className="flex justify-between items-center">
                <div>
                  <h3 className="text-lg font-semibold text-gray-700 font-K2D">
                    {activeTab === 'deadline' ? t("partner.overdueRequests") : t("partner.pendingRequests")}
                  </h3>
                  <p className="text-sm text-gray-500 mt-1">
                    {activeTab === 'deadline' 
                      ? t("partner.overdueCount", { count: missionDeadLine.length }) 
                      : t("partner.inProgressCount", { count: missionInProgress.length })
                    }
                  </p>
                </div>
                
                {utp === 1 && (
                  <button
                    className={`px-4 py-2 text-white rounded-lg hover:opacity-90 transition-all duration-200 font-medium text-sm ${
                      activeTab === 'deadline' 
                        ? missionDeadLine.length === 0 
                          ? 'bg-gray-400 cursor-not-allowed' 
                          : 'bg-red-500 hover:bg-red-600 cursor-pointer'
                        : missionInProgress.length === 0 
                          ? 'bg-gray-400 cursor-not-allowed' 
                          : 'bg-orange-500 hover:bg-orange-600 cursor-pointer'
                    }`}
                    disabled={
                      (activeTab === 'deadline' && missionDeadLine.length === 0) ||
                      (activeTab === 'inProgress' && missionInProgress.length === 0)
                    }
                    onClick={() => {
                      if (activeTab === 'deadline' && selectedIdsRequestDeadLine.length > 0) {
                        openModal(<RelaunchPopup closeModal={closeModal} />);
                      } else if (activeTab === 'inProgress' && selectedIdsRequestInProgress.length > 0) {
                        openModal(
                          <RelaunchPopup
                            closeModal={closeModal}
                            selectedIdsRequestInProgress={selectedIdsRequestInProgress}
                          />
                        );
                      } else {
                        showToastError("Veuillez sélectionner au moins une requête pour relancer ou informer");
                      }
                    }}
                  >
                    {activeTab === 'deadline' ? t("partner.relaunchRequests") : t("partner.informRequests")}
                  </button>
                )}
              </div>
            </div>

            {/* Tableau */}
            <div className="overflow-x-auto max-h-[calc(70vh-10rem)] overflow-y-auto">
              <table className="w-full">
                <thead className="bg-gray-50">
                  <tr className="text-sm text-gray-600">
                    {utp === 1 && (
                      <th className="px-4 py-3 text-left w-12">
                        <input
                          type="checkbox"
                          checked={
                            activeTab === 'deadline' 
                              ? selectedAllDeadLine 
                              : selectedAllInProgress
                          }
                          onChange={
                            activeTab === 'deadline' 
                              ? handlSelectedAllDeadLine 
                              : handlSelectedAllInProgress
                          }
                          className={`rounded border-gray-300 focus:ring-2 focus:ring-offset-2 ${
                            activeTab === 'deadline' 
                              ? 'text-red-600 focus:ring-red-500' 
                              : 'text-orange-600 focus:ring-orange-500'
                          }`}
                        />
                      </th>
                    )}
                    <th className="px-4 py-3 text-left font-medium">{t("common.id")}</th>
                    <th className="px-4 py-3 text-left font-medium">{t("common.category")}</th>
                    <th className="px-4 py-3 text-left font-medium">{t("customerRequests.description")}</th>
                    <th className="px-4 py-3 text-center font-medium">
                      {activeTab === 'deadline' ? t("partner.overdueDays") : t("partner.waitingDays")}
                    </th>
                    <th className="px-4 py-3 text-center font-medium">{t("common.actions")}</th>
                  </tr>
                </thead>

                <tbody className="divide-y divide-gray-100">
                  {(activeTab === 'deadline' ? missionDeadLine : missionInProgress)?.map((mission: any) => (
                    <tr
                      key={mission?.id}
                      className={`hover:bg-gray-50 transition-colors duration-150 ${
                        mission?.isAssigned === true
                          ? "bg-white"
                          : "bg-gray-50 text-gray-400"
                      }`}
                    >
                      {utp === 1 && (
                        <td className="px-4 py-3">
                          <div className="flex items-center gap-2">
                            <input
                              type="checkbox"
                              checked={
                                activeTab === 'deadline'
                                  ? selectedIdsRequestDeadLine.includes(mission.id)
                                  : selectedIdsRequestInProgress.includes(mission.id)
                              }
                              onChange={(e) => {
                                if (activeTab === 'deadline') {
                                  handleCheckboxChangeDeadLine(e, mission.id);
                                } else {
                                  handleCheckboxChangeInProgress(e, mission.id);
                                }
                              }}
                              className={`rounded border-gray-300 focus:ring-2 focus:ring-offset-2 ${
                                activeTab === 'deadline' 
                                  ? 'text-red-600 focus:ring-red-500' 
                                  : 'text-orange-600 focus:ring-orange-500'
                              }`}
                            />
                            {Object.keys(mission?.reminder || {}).length > 0 && (
                              <div
                                className="cursor-help"
                                onMouseEnter={(e) => {
                                  if (Object.keys(mission?.reminder || {}).length > 0) {
                                    const message = activeTab === 'deadline'
                                      ? t("customerRequests.relaunched", {
                                          date: dateFormat(mission?.reminder?.date),
                                          user: mission?.reminder?.user,
                                        })
                                      : t("partner.informedOn", {
                                          date: dateFormat(mission?.reminder?.date),
                                          user: mission?.reminder?.user,
                                        });
                                    handleMouseEnter(message, e);
                                  }
                                }}
                                onMouseLeave={mission?.reminder ? handleMouseLeave : undefined}
                              >
                                📩
                              </div>
                            )}
                          </div>
                        </td>
                      )}
                      <td className="px-4 py-3 text-sm font-medium text-gray-900">
                        {mission?.fakeId}
                      </td>
                      <td className="px-4 py-3 text-sm text-gray-600">
                        {mission?.CategoryDocRequest.name}
                      </td>
                      <td className="px-4 py-3 text-sm text-gray-600">
                        {mission?.description}
                      </td>
                      <td className="px-4 py-3 text-center">
                        <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${
                          activeTab === 'deadline'
                            ? 'bg-red-100 text-red-800'
                            : 'bg-orange-100 text-orange-800'
                        }`}>
                          {mission?.overdue} {t("partner.days")}
                        </span>
                      </td>
                      <td className="px-4 py-3 text-center">
                        <button
                          type="button"
                          className={`p-2 rounded-lg transition-colors duration-150 ${
                            mission?.isAssigned === true
                              ? "text-blue-600 hover:bg-blue-50 cursor-pointer"
                              : "text-gray-400 cursor-not-allowed"
                          }`}
                          onClick={() => {
                            if (utc === 1 && mission?.isAssigned === true) {
                              setOpenDetailsCustomer(true);
                              setRequestIdCustomer(mission?.id);
                            } else if (utc === 1 && mission?.isAssigned === false) {
                              setOpenDetailsCustomer(false);
                            } else setOpenDetails(true);
                            setRequestId(mission?.id);
                          }}
                        >
                          <img src={eye} alt="eye" className="w-4 h-4" />
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      {/* Tooltip */}
      {tooltipState.content && (
        <div
          className="bg-gray-800 text-white p-3 rounded-lg text-sm absolute z-50 w-auto max-w-[250px] shadow-lg"
          style={{
            top: tooltipState.position.y,
            left: tooltipState.position.x,
          }}
        >
          {tooltipState.content}
        </div>
      )}

      <Footer />
    </div>
  );
};

export default RecoveryFile;
